import type {ListingCardProps} from '../listing';
import type {RegisterInterestOpenOptions} from '../register-interest/register-interest-controller';

export interface CardListingTrackedItem {
  id: string;
  name: string;
}

export interface CardListingItem {
  id?: string;
  // What the card's "Register Interest" action pre-fills. Each listing sets
  // its own entity here, not just the project it happens to be filtered by.
  registerInterest?: RegisterInterestOpenOptions;
  title: string;
  image: string;
  href: string;
  primaryMeta?: ListingCardProps['primaryMeta'];
  meta?: ListingCardProps['meta'];
  soldOut?: boolean;
  /** i18n key(s) for status badge(s) (e.g. `delivered_phase` / `sold_out`); takes precedence over `soldOut`. */
  badgeKey?: string[];
  /** Render the resolved status as the image corner tag (with its icon) instead of a body badge — the context label then takes `badges`. */
  statusAsTag?: boolean;
  tags?: ListingCardProps['tags'];
  badges?: ListingCardProps['badges'];
}

export interface CardListingFilterConfig {
  items: {id: string; label: string}[];
  activeId?: string;
}

export interface CardListingServerPaging {
  page: number;
  totalPages: number;
}

// /** Resolve a card's status-badge i18n key(s): explicit `badgeKey` wins, else the `soldOut` flag. */
export function statusBadgeKey(item: CardListingItem): string[] {
  if (item.badgeKey) {
    return item.badgeKey;
  }
  return item.soldOut ? ['sold_out'] : [];
}
